export default {
  unassigned: 'Unassigned',
  assigned: 'Assigned',
  soliciting: 'Soliciting',
  canceled: 'Canceled'
};



// WEBPACK FOOTER //
// ./src/utils/lookStatusConstants.js